<script setup>
import { VForm } from 'vuetify/components'
import topImage from '@/assets/images/pages/fineDining1.webp'
import logoLargeLight from '@/assets/logo-large-light.svg'
import {useRoute} from "vue-router"
import {useAppAbility} from "@/plugins/casl/useAppAbility"
import axios from "@axios"
import {
  alphaDashValidator,
  emailValidator,
  requiredValidator
} from '@validators'
import moment from "moment/moment"
import {useUsersStore} from "@/stores"

const route = useRoute()
const router = useRouter()

const refVForm = ref(null)
const email = ref(route?.query?.email || '')
const referredBy = ref(route?.query?.referredBy || '')
const referredByEmail = ref(route?.query?.referredByEmail || '')
console.log('email', email)
const password = ref('')
const termsAccepted = ref(true)

// Ability
const ability = useAppAbility()

const usersStore = useUsersStore()
let loginDialogVerificationType = null;
({loginDialogVerificationType} = storeToRefs(usersStore))

//set homeRedirectPath to the current path
localStorage.setItem('homeRedirectPath', route.path)

loginDialogVerificationType.value = "partner"
</script>

<template>
  <div>
    <section class="home-masthead">
      <div class="home-masthead-bkg-holder">
        <img
          class="home-masthead-bkg"
          :src="topImage"
        >
      </div>
      <div class="content-wrapper">
        <div class="masthead-content mt-4 mb-0 pl-0 pr-0">
          <b>
            <span><VIcon class="verified-icon">material-symbols:verified</VIcon>Verified profile + 1 yr free Platinum membership</span>
          </b>
          <div>for restaurateurs & investors of Preferred restaurants </div>
          <div class="text-xs">
            (offer valid for a limited time)
          </div>
        </div>
        <div class="masthead-content ">
          <HomeMasthead :join-page="true" />
          <div class="mt-2">
            <VIcon class="verified-icon">
              material-symbols:verified
            </VIcon>Verified profile + 1 yr free Platinum membership<br>
            offer valid for a limited time<br>
          </div>
          <div class="mt-2">
            iOS app available post activation
          </div>
        </div>
      </div>
    </section>


    <HomeMainContent />
  </div>
</template>

<style lang="scss" scoped>
@use "@core/scss/pages/misc.scss";
//
//.v-text-field .v-field--active {
//  opacity: 0;
//}
.v-text-field .v-field--active input {
  opacity: 1;
}
input[type="text"]
{
  background: rgba(0, 0, 0, 0);
  border: none;
  outline: none;
}

.verified-icon {
  color: rgb(0, 149, 246);
  width: 1.25rem;
  height: 1.25rem;
  margin-bottom: 4px;
  margin-right: 1px;
}


.masthead-content {
  padding: 0 1rem;
  margin: 1rem 0;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
